<p class="ion-margin">
  {{ (tooltip || '') | translate }}
</p>
